import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { INotification, authUser } from '../../interfaces';
import { Pillar, Strategy } from '../../interfaces/models/strategy.model';
import { AuthService } from '../../services/auth.service';
import { DirectionService } from '../../services/direction.service';
import { NotificationService } from '../../services/notification.service';
import { SocketService } from '../../services/socket.service';
import { StrategyService } from '../../services/strategy.service';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { SinceDatePipe } from '../../pipes/since-date.pipe';
import { IndicatorsChartsComponent } from '../indicators-charts/indicators-charts.component';
import { DialogModule } from 'primeng/dialog';

import { SidebarModule } from 'primeng/sidebar';
import { StrategicPillarService } from '../../services/strategic-pillar.service';
import { ToastrService } from 'ngx-toastr';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';

import { GoalService } from '../../services/goal.service';
import { TooltipModule } from 'primeng/tooltip';
import { NotificationsComponent } from '../../shared/components/notifications/notifications.component';
import { SpinnerService } from '../../services/spinner.service';
import { GoalTreeComponent } from '../../shared/goal-tree/goal-tree.component';

import { NavTitlePipe } from '../../pipes/nav-title.pipe';

@Component({
  selector: 'app-strategy-manager-home',
  standalone: true,
  imports: [
    NavTitlePipe,
    InputTextModule,
    InputTextareaModule,
    TooltipModule,
    ProgressBarModule,
    SidebarModule,
    DialogModule,
    IndicatorsChartsComponent,
    RouterModule,
    SinceDatePipe,
    TableModule,
    TranslateModule,
    TagModule,
    CommonModule,
    DropdownModule,
    ButtonModule,
    FormsModule,
    NotificationsComponent,
    GoalTreeComponent

  ],
  templateUrl: './strategy-manager-home.component.html',
  styleUrl: './strategy-manager-home.component.scss'
})
export class StrategyManagerHomeComponent implements OnDestroy, OnInit, AfterViewInit {
  @ViewChild('pillarForm') pillarForm!: FormGroup;
  @ViewChild('goalForm') goalForm!: FormGroup;
  visible = false
  selectedNotificaton = {} as any
  strategyOptions = [] as { name: string, strategyId: number }[];
  selectedStrategyId = 0;
  currentVariant: 'a' | 'b' = 'a'; // Theme variant (calm/glass)

  tabletype = 'goalsAndIndicators'
  isVisibleGoalModal = false;
  selectedStrategy = {} as Strategy;
  alignmentStrategy = {} as any;
  selectedPillar = { id: 0 } as any;
  dir!: "rtl" | "ltr";
  notifications = [] as INotification[];
  pillars = [] as any
  toggleStates: { [goalId: number]: boolean } = {};
  isModalVisible = false
  expandedPillars: { [pillarId: number]: boolean } = {}; // Track expanded pillars
  project = {} as any
  selectedProject = {} as any
  user!: authUser;
  isPillarSideBarVisible = false;
  isGoalSideBarVisible = false;
  Pillarsoptions = [] as any
  isAllNotificationsVisible = false;
  isQuickActionsOpen = false;
  private unsubscribe$ = new Subject<void>();
  NotificationTypesEnum = {
    submission_request: "submission_request",
    submission_response: "submission_response",
    milestone_output_audit_request: "milestone_output_audit_request",
    milestone_output_audit_response: "milestone_output_audit_response",
    outcome_proof_audit_request: "outcome_proof_audit_request",
    outcome_proof_audit_response: "outcome_proof_audit_response"
  }
  constructor(
    private strategyService: StrategyService,
    private directionService: DirectionService,
    private socketService: SocketService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private strategicPillarService: StrategicPillarService,
    private toastr: ToastrService,
    private goalService: GoalService,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  
  ngAfterViewInit(): void {
    // Counter animation for KPIs
    setTimeout(() => {
      this.animateCounters();
    }, 300);
  }
  
  ngOnInit(): void {
    this.authService.authBufferSub$.pipe(takeUntil(this.unsubscribe$))
      .subscribe((user) => {
        this.user = user as authUser;
      })


    this.route.data.pipe(takeUntil(this.unsubscribe$))
      .subscribe(({ viewBag }) => {
        this.strategyOptions = viewBag.stratgies.map((x: any) => ({ name: x.name, strategyId: x.id }))
        this.strategyService.setStrategyIdfn(this.selectedStrategyId)
        this.alignmentStrategy = viewBag.strategyAlignment['data']['strategy'];
        this.pillars = [...this.alignmentStrategy.pillars]
        this.selectedStrategyId = this.alignmentStrategy.id;
        this.selectedStrategy = this.alignmentStrategy as Strategy;
        this.Pillarsoptions = viewBag.pillars.map((x: Pillar) => { return { name: x.name, pillarId: x.id } })
        
        // Set first pillar as default
        if (this.alignmentStrategy?.pillars?.length > 0) {
          this.selectedPillar = this.alignmentStrategy.pillars[0];
        }
      })
    this.socketService.refreshNotification$.pipe(takeUntil(this.unsubscribe$))
      .subscribe((response: any) => {
        this.notifications = response["data"]["notifications"];
      });
    this.directionService.direction$.pipe(takeUntil(this.unsubscribe$))
      .subscribe(dir => {
        this.dir = dir;
      })
  }


  strategyOptionsChange() {
    this.strategyService.setStrategyIdfn(+this.selectedStrategyId);
    this.strategyService.getStrategyById(this.selectedStrategyId.toString()).subscribe((strategy: any) => {
      this.selectedStrategy = strategy['data']['strategy'] as Strategy;
      this.strategyService.getStrategyAlignment(this.selectedStrategyId.toString()).subscribe((response: any) => {
        this.alignmentStrategy = response['data']['strategy'];
        this.pillars = [...this.alignmentStrategy.pillars]
        this.Pillarsoptions = this.pillars.map((x: Pillar) => { return { name: x.name, pillarId: x.id } })
        
        // Set first pillar as default
        if (this.alignmentStrategy?.pillars?.length > 0) {
          this.selectedPillar = this.alignmentStrategy.pillars[0];
        } else {
          this.selectedPillar = { id: 0 };
        }
        
        // Re-animate counters after data update
        setTimeout(() => {
          this.animateCounters();
        }, 100);
      })
    })
    this.socketService.setRefreshNotification(this.selectedStrategyId)
  }
  gotoAddProject() {

  }
  selectPillarFn(pillar: any) {
    this.toggleStates = {};
    if (!Object.keys(pillar).length) {
      this.selectedPillar = { id: 0 };
      this.pillars = []
      this.pillars = [...this.alignmentStrategy.pillars]
    } else {
      this.pillars = []
      this.pillars.push(pillar)
      this.selectedPillar = pillar;

    }
  }
  
  togglePillar(pillarId: number) {
    // Toggle the specific pillar
    this.expandedPillars[pillarId] = !this.expandedPillars[pillarId];
  }
  
  isPillarExpanded(pillarId: number): boolean {
    return this.expandedPillars[pillarId] || false;
  }
  
  getPillarCount(pillar: any): number {
    // Simple counter: number of goals in this pillar
    return pillar.goals?.length || 0;
  }

  getPillarIndicatorsCount(pillar: any): number {
    // Count total indicators for this pillar
    if (!pillar?.goals) return 0;
    return pillar.goals.reduce((total: number, goal: any) => {
      return total + (goal.no_indicators || 0);
    }, 0);
  }

  onPillarChange() {
    // Keep dropdown and chips in sync
  }

  selectPillarChip(pillar: any) {
    this.selectedPillar = pillar;
  }

  goTo(section: string) {
    const strategyId = +(this.selectedStrategyId || this.alignmentStrategy?.id || 0);
    if (strategyId) {
      this.strategyService.setStrategyIdfn(strategyId);
    }

    switch (section) {
      case 'pillars':
        if (strategyId) this.router.navigate(['/strategicPillar', strategyId]);
        break;
      case 'goals':
        this.router.navigate(['/strategies/goals']);
        break;
      case 'indicators':
        this.router.navigate(['/strategies/indicators']);
        break;
      case 'projects':
        this.router.navigate(['/strategies/projects']);
        break;
      case 'dashboard':
        this.router.navigate(['/dashboard']);
        break;
      case 'performance':
        this.router.navigate(['/performance']);
        break;
      case 'reports':
        this.router.navigate(['/reports']);
        break;
      case 'alignment':
        if (strategyId) this.router.navigate(['/strategy-alignment', strategyId]);
        break;
    }
  }

  goToGoal(goal: any) {
    const strategyId = this.selectedStrategyId || this.alignmentStrategy?.id;
    if (strategyId) {
      this.strategyService.setStrategyIdfn(+strategyId);
    }
    this.router.navigate(['/strategies/goals'], {
      queryParams: goal?.id ? { goalId: goal.id } : undefined
    });
  }

  markAsRead(notificationId: number) {
    const notification = this.notifications.find(n => n.id == notificationId) as INotification
    if (notification.is_read) {
      return;
    } else {

      this.notificationService.markAsRead(notificationId).subscribe(() => {
        notification["is_read"] = true
      })
    }
  }

  navigateToEntity(notification: INotification) {
    if (notification.type == 'assessment_response' || notification.type == 'submission_request') {
      // this.router.navigateByUrl(`strategies/${this.se}/projects/48`)
    }
  }
  allNotifications() {
    this.isAllNotificationsVisible = true;
  }
  onToggle(goalId: number): void {
    // Toggle the state for the specific goal
    this.toggleStates[goalId] = !this.toggleStates[goalId];
    console.log(this.toggleStates[goalId]);
  }

  isToggled(goalId: number): boolean {
    // Return true if the details element is toggled open, false otherwise
    return this.toggleStates[goalId] ?? false;
  }

  closeModal() {
    this.tabletype = 'goalsAndIndicators'
    this.isModalVisible = false;
  }

  tableType(tableType: string) {
    this.tabletype = tableType;
  }
  showModal(project: any) {
    this.selectedProject = project;
    this.strategyService.GetProjectPerformance(this.selectedStrategyId, project.id).subscribe((response: any) => {
      this.project = response['data'];
      console.log('this.project', this.project);
    })

    // this.strategyService.
    this.isModalVisible = true;
  }
  // getWeightColor(weight: number) {
  //   if (weight == 1) return weightColors[1]
  //   if (weight > 1 && weight <= 5) return weightColors[5]
  //   if (weight > 5 && weight <= 10) return weightColors[10]
  //   if (weight > 10 && weight <= 15) return weightColors[15]
  //   if (weight > 15 && weight <= 20) return weightColors[20]
  //   if (weight > 20 && weight <= 25) return weightColors[25]
  //   return ''
  // }
  selectNotification(notificationId: number) {
    this.selectedNotificaton = this.notifications.find(x => x.id == notificationId) as any;
    this.visible = true;
  }

  openPillarSideBar() {
    this.pillarForm.reset({});
    this.isPillarSideBarVisible = true;
  }
  openGoalSideBar() {
    this.goalForm.reset({});
    this.isGoalSideBarVisible = true;
  }
  submitPillar() {
    //create 
    if (this.pillarForm.valid) {
      this.strategicPillarService.createPillars(this.pillarForm.value, +this.selectedStrategyId).subscribe((response: any) => {

        this.alignmentStrategy.pillars.push({ ...this.pillarForm.value, id: response['data']['entity'].id, goals: [] })
        this.Pillarsoptions.push({ name: this.pillarForm.value['name'], pillarId: response['data']['entity'].id })
        this.pillars = [...this.alignmentStrategy.pillars]
        this.toastr.success("تمت الاضافة ", "عملية ناجحة");
        this.pillarForm.reset({});
        this.isPillarSideBarVisible = false;

      })
    }
  }
  submitGoal() {

    if (this.goalForm.valid) {
      this.goalService.createGoal(this.goalForm.value, +this.selectedStrategyId).subscribe((response: any) => {
        this.alignmentStrategy.pillars.find((x: any) => x.id == this.goalForm.value.pillar_id).goals.push({
          ...this.goalForm.value,
          "no_indicators": 0,
          "no_projects": 0
        })
        this.toastr.success("تمت الاضافة ", "عملية ناجحة");
        this.goalForm.reset({});
        this.isGoalSideBarVisible = false;
      })
    }
  }

  // ===== Modern Design Helper Methods =====
  
  getTotalPillarsCount(): number {
    if (!this.alignmentStrategy?.pillars) return 0;
    return this.alignmentStrategy.pillars.length;
  }

  getTotalGoalsCount(): number {
    if (!this.alignmentStrategy?.pillars) return 0;
    return this.alignmentStrategy.pillars.reduce((total: number, pillar: any) => {
      return total + (pillar.goals?.length || 0);
    }, 0);
  }

  getTotalIndicatorsCount(): number {
    if (!this.alignmentStrategy?.pillars) return 0;
    return this.alignmentStrategy.pillars.reduce((total: number, pillar: any) => {
      return total + (pillar.goals?.reduce((sum: number, goal: any) => sum + (goal.no_indicators || 0), 0) || 0);
    }, 0);
  }

  getTotalProjectsCount(): number {
    return this.alignmentStrategy?.no_projects ?? 0;
  }

  getTotalValuesCount(): number {
    if (!this.selectedStrategy?.values) return 0;
    return this.selectedStrategy.values.length;
  }

  calculateGoalProgress(goal: any): number {
    // Simple counter - just return the count
    return (goal.no_indicators || 0) + (goal.no_projects || 0);
  }
  
  calculateGoalProgressPercentage(goal: any): number {
    // For ring visual only
    const count = this.calculateGoalProgress(goal);
    return Math.min(count * 10, 100);
  }

  getNotificationTypeLabel(type: string): string {
    const labels: { [key: string]: string } = {
      'submission_request': this.dir === 'rtl' ? 'طلب تقديم' : 'Submission Request',
      'submission_response': this.dir === 'rtl' ? 'رد على طلب' : 'Submission Response',
      'milestone_output_audit_request': this.dir === 'rtl' ? 'طلب مراجعة' : 'Audit Request',
      'milestone_output_audit_response': this.dir === 'rtl' ? 'رد مراجعة' : 'Audit Response',
      'outcome_proof_audit_request': this.dir === 'rtl' ? 'طلب تدقيق' : 'Proof Audit',
      'outcome_proof_audit_response': this.dir === 'rtl' ? 'رد تدقيق' : 'Audit Response'
    };
    return labels[type] || type;
  }

  toggleVariant() {
    this.currentVariant = this.currentVariant === 'a' ? 'b' : 'a';
  }

  animateCounters() {
    const counters = document.querySelectorAll('.count-animation');
    counters.forEach((counter: any) => {
      // Reset to 0 first
      counter.textContent = '0';
      
      const target = +counter.getAttribute('data-target') || 0;
      const duration = 1500; // milliseconds
      const step = Math.max(1, Math.ceil(target / 60)); // ~60 frames, minimum 1
      const interval = duration / 60;
      
      let current = 0;
      const timer = setInterval(() => {
        current += step;
        if (current >= target) {
          current = target;
          clearInterval(timer);
        }
        counter.textContent = current.toString();
      }, interval);
    });
  }

  toggleQuickActions() {
    this.isQuickActionsOpen = !this.isQuickActionsOpen;
  }

}
